import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#111d4e',
      default: '#111d4e'
    },
    secondary: {
      main: '#111d4e'
    },
    text: {
      primary: '#111d4e',
      secondary: '#111d4e'
    }
  },
  shadows,
  typography
});

export default theme;
